import * as React from 'react';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';

export const CustomWidthTooltipNoImage = styled(({ className, ...props }) => (      
    <Tooltip {...props} classes={{ popper: className }} 
      slotProps={{
        tooltip: {
          sx: {
            fontSize: '1.2rem', 
          },
        },
      }} 
    />        
  ))
  (({ dynamicWidth, dynamicHeight }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      maxWidth: dynamicWidth, 
      height: dynamicHeight,
      whiteSpace: 'normal',
      backgroundColor: '#1f1d1d',
    },
}))
